export function detectPlatform(userAgent) {
  const ua = userAgent || '';

  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isIPadOS =
    /Macintosh/i.test(ua) &&
    typeof navigator !== 'undefined' &&
    navigator.maxTouchPoints > 1;

  if (isIOS || isIPadOS) {
    return 'ios';
  }

  if (/Android/i.test(ua)) {
    return 'android';
  }

  if (/Mobile|webOS|BlackBerry|Opera Mini|IEMobile/i.test(ua)) {
    return 'unknown-mobile';
  }

  return 'desktop';
}
